import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import LockClosedIcon from '@heroicons/react/outline/LockClosedIcon';
import RssIcon from '@heroicons/react/outline/RssIcon';
import { useClipboard } from 'use-clipboard-copy';
import { Input } from '@tribeplatform/react-ui-kit/Input';
import { Link } from '@tribeplatform/react-ui-kit/Link';
import { useDomain } from '../common';
import { T } from '../i18n';
export const ShareRss = ({ postId, memberId, spaceId, isPrivate, }) => {
    const { domain, subfolder } = useDomain();
    const [copied, setCopied] = useState(false);
    const clipboard = useClipboard();
    let url = '';
    if (postId) {
        url = `https://${domain}${subfolder}/rss/post/${postId}/replies`;
    }
    else if (spaceId) {
        url = `https://${domain}${subfolder}/rss/${spaceId}/posts`;
    }
    else if (memberId) {
        url = `https://${domain}${subfolder}/rss/member/${memberId}/posts`;
    }
    else {
        return null;
    }
    return (_jsxs("div", { className: "flex flex-col space-y-5", children: [!isPrivate && (_jsx(_Fragment, { children: _jsx(Input, { onClick: e => e.currentTarget.select(), value: url, readOnly: true, trailingAddon: _jsx(Link, { onClick: () => {
                            clipboard.copy(url);
                            setCopied(true);
                            setTimeout(() => setCopied(false), 2000);
                        }, variant: "neutral", children: _jsx(T, { id: "Generics.CopyTooltip", defaultMessage: "{copied, select, true {Copied} other {Copy}}", values: { copied } }, void 0) }, void 0) }, void 0) }, void 0)), _jsxs("p", { className: "flex space-s-3 items-center", children: [_jsx(RssIcon, { className: "w-16 h-16 text-[#ee802f]" }, void 0), _jsx("span", { children: _jsx(T, { defaultMessage: "Add the feed of this page to your blog or favorite RSS reader such as Feedly or Mailbrew to stay up to date!", id: "ShareRss.Description" }, void 0) }, void 0)] }, void 0), isPrivate && (_jsxs("div", { className: "bg-surface-subdued rounded-md p-3 flex text-sm", children: [_jsx(LockClosedIcon, { className: "flex-shrink-0 w-5 h-5 me-2 inline-block" }, void 0), _jsx("span", { children: _jsx(T, { defaultMessage: "<strong>This page is private</strong>. RSS feed only works with public pages.", id: "ShareRss.PrivatePageNotice" }, void 0) }, void 0)] }, void 0))] }, void 0));
};
//# sourceMappingURL=ShareRss.js.map